import { render, staticRenderFns } from "./DistributeRolesModal.vue?vue&type=template&id=ac52b6fe&scoped=true"
import script from "./DistributeRolesModal.vue?vue&type=script&lang=js"
export * from "./DistributeRolesModal.vue?vue&type=script&lang=js"
import style0 from "./DistributeRolesModal.vue?vue&type=style&index=0&id=ac52b6fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac52b6fe",
  null
  
)

export default component.exports